var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteriorPilotSharpshooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sharpshooter",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3600 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #232323;\n      }\n\n      .cls-2 {\n        fill: #898881;\n        opacity: .3;\n      }\n\n      .cls-3 {\n        fill: #777c7b;\n      }\n\n      .cls-4 {\n        fill: #4f5656;\n      }\n\n      .cls-5 {\n        fill: #ab19af;\n      }\n\n      .cls-6 {\n        fill: #f7edef;\n      }\n\n      .cls-7 {\n        fill: #3c3f3f;\n      }\n\n      .cls-8 {\n        fill: #262828;\n      }\n\n      .cls-9 {\n        fill: #f4f4f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 342.76,
    y: 1598.79,
    width: 369.57,
    height: 203.35,
    transform: "translate(1055.09 3400.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "688.12 1806.98 781.73 1806.98 800.73 1666.53 755.91 1543.92 709.1 1555.22 680.05 1607.31 675.33 1731.94 688.12 1806.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "369.52 1806.98 275.92 1806.98 256.92 1666.53 301.74 1543.92 348.54 1555.22 377.59 1607.31 382.32 1731.94 369.52 1806.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "486.91 1305.5 570.88 1305.5 646.54 1351.19 698.9 1629.68 668.47 1621.5 666.15 1654.25 613.8 1646.23 570.88 1682.67 528.9 1658.11 486.91 1682.67 444 1646.23 391.64 1654.25 389.33 1621.5 358.9 1629.68 411.25 1351.19 486.91 1305.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "599.36 1470.66 633.44 1493.45 674.05 1493.53 662.59 1374.42 635.68 1372.39 599.36 1395.65 599.36 1470.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "674.53 1502.5 692.61 1493.21 671.43 1371.24 651.04 1367.34 674.53 1502.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 394.96,
    y: 1494.95,
    width: 67.78,
    height: 22.59,
    transform: "translate(-575.5 2707.91) rotate(-124.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 232.31,
    y: 1509.66,
    width: 380.87,
    height: 17.09,
    transform: "translate(-594.93 2721.54) rotate(-124.22)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "282.74 1299.2 291.06 1298.76 332.59 1359.82 331.12 1365.84 315.17 1376.69 309.02 1375.85 268.08 1315.76 270.97 1307.21 282.74 1299.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 278.9,
    y: 1329.28,
    width: 22.57,
    height: 5.56,
    transform: "translate(-648.11 2321.09) rotate(-124.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 274.14,
    y: 1313.02,
    width: 9.59,
    height: 5.56,
    transform: "translate(-652.24 2286.4) rotate(-124.22)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "381.54 1491.21 514.22 1686.3 522.23 1680.86 367.04 1452.66 381.54 1491.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "291.76 1298.92 309.24 1324.63 312.22 1322.6 298.74 1294.17 291.76 1298.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "377.98 1425.7 401.41 1460.15 482.72 1571.11 493.39 1563.85 420.09 1447.45 396.66 1412.99 377.98 1425.7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "820.97 2127 237.03 2127 205 1723.7 311.75 1570.95 746.25 1570.95 853 1723.7 820.97 2127"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "725.15 2098.1 332.85 2098.1 302.85 1723.03 340.36 1673.03 714.5 1673.03 755.15 1723.03 725.15 2098.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorPilotSharpshooter);
export default __webpack_public_path__ + "static/media/interior-pilot-sharpshooter.7cad3876d041ec5b35fa5849231770e1.svg";
export { ForwardRef as ReactComponent };